import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgF35BLightningIi = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 50"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="m25.389 0 21.553 23.856 15.067-.57 16.51-.557c15.853-.584 37.816-1.847 37.816-1.847l2.633.133s8.951-2.28 25.722-2.055c.416-.105 3.95-.99 7.866-.99 8.257 0 13.741 3.363 14.495 3.852l.089.059 1.11.695c2.303 1.345 4.652 2.858 6.377 4l2.893 1.813.483.057c.674.09 1.678.272 2.351.604l.267.152c1 .667 14.537 3.508 19.379 6.852l-1.855.842c-2.856 1.268-8.399 3.616-12.211 4.514l-2.1 2.223-1.924.267q-.483.065-3.098.3c-.28.017-.5.02-.632.003-.564-.066-2.544-.947-3.942-1.561l-3.746.311c-10.567.855-25.572 1.881-40.329 2.289l-2.443.538c-2.142.461-5.068 1.06-6.084 1.126l-.561.004c-3.54-.014-26.608-.15-29.547-.007l-.533.03c-3.358.147-18.191.147-18.99.147-.832 0-5.847 1.672-8.35 1.837l-2.315.136c-4.31.231-11.144.497-12.05.271-2.005-.5-8.191-3.37-11.03-4.207-2.841-.834-6.35-1.378-7.854-1.713-1.507-.334-8.857-3.84-8.857-3.84l.002-.008-.097-.038.336-1.799q-2.67 0-4.403-.437l-.839-.27C14.103 36.287 5.884 34.195 0 34.048l.406-.157-.254-.007 9.701-3.68 1.872-.08c.696-.026 1.52-.05 2.352-.061l3.67-.127s1.7.233 4.274.572l.051-.006L6.755 0z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgF35BLightningIi
